
import './App.css';
import Header from './Header';
import Home from './Home';
import Skills from './Skills'
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Projects from './Projects';
import Contact from './Contact';
import Blogs from './Blogs';

function App() {
  // const [isMobile, setIsMobile] = useState(false);

  // useEffect(() => {
  //   if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  //     setIsMobile(true);
  //   }
  // }, []);
  // style={isMobile ? { width: '100%' } : undefined}
  return (
    <Router>
      <div className="app" >
        <Routes>
          <Route path="/" 
            element={
              <>
                <Header />
                <Home/>
              </>}
          />

          <Route path="/projects" 
            element={
              <>
                <Header />
                <Projects />
              </>}
          />

          <Route path="/skills" 
            element={
              <>
                <Header />
                <Skills />
              </>}
          />

          <Route path="/blogs" 
            element={
              <>
                <Header />
                <Blogs />
              </>}
          />
          
          <Route path="/contact" 
            element={
              <>
                <Header />
                <Contact />
              </>}
          />
          
        </Routes>
        
      </div>
    </Router>
    
    
  );
}

export default App;
